import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Helmet } from 'react-helmet';

import { RadioOptionsWithConfirm } from 'shared-components';

import { ApplicationState } from '../../../../store';
import * as StudentActions from '../../../../store/student/actions';
import * as PIActions from '../../../../store/student/personalInfo/actions';
import {
  createNavigateBackwardAction,
  createNavigateForwardAction,
  createNavigateToAction
} from '../../../../middleware/actions';
import { toggleTaskMenu } from '../../../../store/ui/actions';

import { Q } from '../../../../store/student/types';
import { ConfigField } from '../../../../types';
import { Pages } from '../../../../store/student/personalInfo/types';

import QuestionPage from '../../../templates/question';
import { titleAppend } from '../../../../utilities/head';

const PersonalQPage8 = () => {
  // dispatch actions
  const dispatch = useDispatch();

  const onPrevious = () => dispatch(createNavigateBackwardAction());
  const onNext = (config: any) => {
    dispatch(StudentActions.savePersonalInfo(Pages.PAGE8, config));
    dispatch(createNavigateForwardAction());
  };
  const onSkip = () => dispatch(createNavigateForwardAction());
  const onChange = (fieldName: string, value: any, refValue?: any) =>
    dispatch(PIActions.createUpdatePIFieldAction(fieldName, value, refValue));
  const onBackToTaskList = () => {
    dispatch(createNavigateToAction('/dashboard'));
    dispatch(toggleTaskMenu(false));
  };

  // state props from store
  const student = useSelector(({ student }: ApplicationState) => student, shallowEqual);

  const config = useSelector(({ config }: ApplicationState) => config, shallowEqual);

  const {
    WithAgent: withAgentConfig
  }: {
    WithAgent: ConfigField;
  } = config.Checklist.PersonalInfo.Page8;

  const { withAgent = withAgentConfig?.defaultValue } = student.personalInfo;

  const [complete, setComplete] = useState(false);

  useEffect(() => {
    setComplete(!withAgentConfig?.visible || !withAgentConfig?.mandatory || withAgent !== '');
  }, [withAgent, withAgentConfig]);

  const sectionTitle = config.Checklist.PersonalInfo.shortTitle;
  const currentStep = 8;
  const steps = 10;

  const handleAgentClick = (question: any) => {
    if (question.label === 'No, I did it myself') {
      // NB! label change without running script (script triggers email send)
      onChange(Q.AGENT, 'No');
    } else if (question.label === 'Yes, a school counsellor') {
      onChange(Q.AGENT, 'School');
    } else if (question.label === 'Yes, an agent') {
      onChange(Q.AGENT, 'Agent');
    } else if (question.label === 'Yes, someone else') {
      onChange(Q.AGENT, 'Other');
    }
  };

  return (
    <QuestionPage
      complete={complete}
      currentStep={currentStep}
      steps={steps}
      onNext={() => onNext(config)}
      onSkip={onSkip}
      onPrevious={onPrevious}
      onBackToTaskList={onBackToTaskList}
      section={sectionTitle}
    >
      <Helmet>
        <title>
          {`${sectionTitle}: Step ${currentStep}`} {titleAppend}
        </title>
      </Helmet>

      {withAgentConfig?.visible && (
        <RadioOptionsWithConfirm
          key={Q.AGENT}
          id={Q.AGENT}
          label={withAgentConfig?.label}
          inputHelperText={withAgentConfig?.helpText}
          autofocus={true}
          onClick={(question: any) => handleAgentClick(question)}
          questions={[
            {
              char: '1',
              label: 'No, I did it myself',
              selected: withAgent === 'No'
            },
            {
              char: '2',
              label: 'Yes, a school counsellor',
              selected: withAgent === 'School'
            },
            {
              char: '3',
              label: 'Yes, an agent',
              selected: withAgent === 'Agent'
            },
            {
              char: '4',
              label: 'Yes, someone else',
              selected: withAgent === 'Other'
            }
          ]}
        />
      )}
    </QuestionPage>
  );
};

export default PersonalQPage8;
